import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export const EMPTY_NOTES = {
  subjective: "",
  objective: "",
  assessment: "",
  plan: "",
  notes: "",
};

export function hasAnyNote(n) {
  if (!n) return false;
  return Boolean(n.subjective || n.objective || n.assessment || n.plan || n.notes);
}

export default function ClinicalNotesForm({ value, onChange, idPrefix = "notes", objectivePrefill = "" }) {
  const n = value || EMPTY_NOTES;

  const set = (k, val) => onChange({ ...n, [k]: val });

  const insertObjectivePrefill = () => {
    const current = n.objective || "";
    const prefill = objectivePrefill || "Vitals:\nNo vitals recorded.\n\nPhysical Exam / Objective Findings:\n";

    if (!current.trim()) {
      set("objective", prefill);
      return;
    }

    if (current.includes("Vitals:")) return;

    set("objective", `${prefill}\n${current}`);
  };

  return (
    <div className="space-y-3">
      <div>
        <Label className="text-xs font-semibold text-slate-700">
          S — Subjective
        </Label>
        <Textarea
          rows={2}
          value={n.subjective || ""}
          onChange={(e) => set("subjective", e.target.value)}
          placeholder="Chief complaint, history of present illness..."
          data-testid={`${idPrefix}-subjective`}
        />
      </div>

      <div>
        <div className="flex items-center justify-between gap-2 mb-1">
          <Label className="text-xs font-semibold text-slate-700">
            O — Objective
          </Label>
          <button
            type="button"
            onClick={insertObjectivePrefill}
            className="text-xs text-blue-700 hover:text-blue-900 font-medium"
            data-testid={`${idPrefix}-insert-latest-vitals`}
          >
            + Insert Latest Vitals
          </button>
        </div>
        <Textarea
          rows={7}
          value={n.objective || ""}
          onChange={(e) => set("objective", e.target.value)}
          placeholder="Latest vitals, physical exam findings, lab results..."
          data-testid={`${idPrefix}-objective`}
        />
      </div>

      <div>
        <Label className="text-xs font-semibold text-slate-700">
          A — Assessment
        </Label>
        <Textarea
          rows={2}
          value={n.assessment || ""}
          onChange={(e) => set("assessment", e.target.value)}
          placeholder="Diagnosis / impression..."
          data-testid={`${idPrefix}-assessment`}
        />
      </div>

      <div>
        <Label className="text-xs font-semibold text-slate-700">
          P — Plan
        </Label>
        <Textarea
          rows={2}
          value={n.plan || ""}
          onChange={(e) => set("plan", e.target.value)}
          placeholder="Treatment plan, medications, follow-up..."
          data-testid={`${idPrefix}-plan`}
        />
      </div>

      <div>
        <Label className="text-xs font-semibold text-slate-700">
          Additional Notes
        </Label>
        <Textarea
          rows={2}
          value={n.notes || ""}
          onChange={(e) => set("notes", e.target.value)}
          placeholder="Optional additional notes..."
          data-testid={`${idPrefix}-notes`}
        />
      </div>
    </div>
  );
}
